import { RouteObject } from "react-router-dom";
import Login from "../pages/Login";
import Cadastro from "../pages/Cadastro";
import Conta from "../pages/Dashboard/Conta";
import NotFound from "../pages/NotFound";
import RecuperarSenha from "../pages/RecuperarSenha";
import PlanosDeTrabalho from "../pages/Dashboard/PlanosDeTrabalho";
import NovoPlano from "../pages/NovoPlano";
import ProtectedRoute from "../components/ProtectedRoute";
import Logout from "../pages/Logout";
import ContextoPlanoDeTrabalho from "../pages/Dashboard/ContextoPlanoDeTrabalho";
import Editais from "../pages/Dashboard/Editais";
import NovaPrestacaoContas from "../pages/NovaPrestacaoContas";

export const routes: RouteObject[] = [
  {
    path: "/",
    element: <Login />,
  },
  {
    path: "/cadastro",
    element: <Cadastro />,
  },
  {
    path: "/recuperar-senha",
    element: <RecuperarSenha />,
  },
  {
    path: "/logout",
    element: (
      <ProtectedRoute>
        <Logout />
      </ProtectedRoute>
    ),
  },
  {
    path: "/conta",
    element: (
      <ProtectedRoute>
        <Conta />
      </ProtectedRoute>
    ),
  },
  {
    path: "/planos-de-trabalho",
    children: [
      {
        index: true,
        element: (
          <ProtectedRoute>
            <PlanosDeTrabalho />
          </ProtectedRoute>
        ),
      },
      {
        path: "/planos-de-trabalho/:id",
        element: (
          <ProtectedRoute>
            <ContextoPlanoDeTrabalho />
          </ProtectedRoute>
        ),
      },
    ],
  },
  {
    path: "/editais",
    element: (
      <ProtectedRoute>
        <Editais />
      </ProtectedRoute>
    ),
  },
  {
    path: "/novo-plano",
    element: (
      <ProtectedRoute>
        <NovoPlano />
      </ProtectedRoute>
    ),
  },
  {
    path: "/nova-prestacao-de-contas",
    element: (
      <ProtectedRoute>
        <NovaPrestacaoContas />
      </ProtectedRoute>
    ),
  },
  {
    path: "/*",
    element: <NotFound />,
  },
];
